import React from 'react';
import styled from 'styled-components';
import MUITab from '@material-ui/core/Tab';

const StyledMUITab = styled(MUITab)`
  ${props => props.theme.typography.button}
  height: 20px;
  margin: 0 8px 0 0;
  min-height: 40px;
  min-width: initial;
  padding: 0 ${props => props.theme.spacing[2]};
  color: ${props => props.theme.colors.text.primary};
  border: 1px solid ${props => props.theme.colors.brand.primary};
  border-radius: ${props => props.theme.borderRadius.large};

  & .MuiTab-wrapper {
    position: relative;
    top: 2px; /* !!! This is a hack to get around the font Intro is not vertically aligned */
  }

  & .MuiTouchRipple-root {
    border-radius: ${props => props.theme.borderRadius.large};
  }
`;

const Tab = props => <StyledMUITab {...props} />;

export default Tab;
